module.exports = __webpack_public_path__ + "static/media/arrow-swiper.630a2ec4.svg";